var ContourType;
(function (ContourType) {
    ContourType["CLOSED_PLANAR"] = "CLOSED_PLANAR";
    ContourType["OPEN_PLANAR"] = "OPEN_PLANAR";
})(ContourType || (ContourType = {}));
export default ContourType;
